import { AbstractControl, ValidationErrors } from '@angular/forms'

export function notAllNumbersValidator(control: AbstractControl): ValidationErrors | null {
  return /^\d+$/.test(control.value) ? { allNumbers: true } : null
}
